import withHtmlSafe from '../withHtmlSafe';
import Text from './Text';
export default withHtmlSafe(Text);